import { Drawer } from "antd";
import React from "react";

interface FAQDrawerProps {
  isVisible: boolean;
  onClose: () => void;
  faqLink: string;
  fileExtension?: string;
}

const FAQDrawer: React.FC<FAQDrawerProps> = ({
  isVisible,
  onClose,
  faqLink,
  fileExtension,
}) => {
  return (
    <Drawer
      className="faq-drawer"
      title="FAQ Details"
      open={isVisible}
      onClose={onClose}
      width={800}
      style={{ overflow: "hidden" }}
      bodyStyle={{ overflow: "hidden" }}
    >
      {faqLink ? (
        <iframe
          src={faqLink}
          width="100%"
          height="100%"
          style={{ border: "none", minHeight: "500px" }}
          title="FAQ Detail"
        />
      ) : (
        <p>No FAQ available or link is inaccessible.</p>
      )}
    </Drawer>
  );
};

export default FAQDrawer;
